<template>
  <modal-wrapper>
    <modal-container
      class="sharing-modal"
      :show-close="false"
    >
      <div class="register-page__modal-img-wrap">
        <img
          src="@/assets/img/success.svg"
          class="register-page__modal-img"
          width="150"
          height="150"
        />

      </div>
      <div class="sharing-modal__text-block">
        <div class="register-page__modal-sub-text align-center">
          {{ $t('qr-code.scan-qr-mobile-success1') }}
        </div>
        <div class="register-page__modal-sub-text text-center">
          {{ $t('qr-code.scan-qr-mobile-success2') }}
        </div>
      </div>
      <icu-contacts view-type="horizontal" :show-phone="false" email-to="support" />
    </modal-container>
  </modal-wrapper>
</template>

<script>
import ModalWrapper from '@/components/modals/ModalWrapper'
import ModalContainer from '@/components/modals/ModalContainer'
import IcuContacts from '@/components/common/IcuContacts'

export default {
  name: 'DiyaMobileSuccess',
  components: {
    IcuContacts,
    ModalContainer,
    ModalWrapper
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";
@import "~@/assets/scss/views/register-common.scss";


.sub-text {
  padding-top: 20px;
}

.contacts {
  display: flex;
  margin-top: 20px;
  justify-content: center;
}

.sharing-modal {
  min-height: 600px;
  display: flex;
  padding-top: 20px;
  flex-direction: column;
  justify-content: space-between;
}
.sharing-modal__text-block {
  flex-grow: 1;
  font-weight: 700;
  text-align: center;
}

.register-page__modal-img-wrap {
  padding: 70px;
}
</style>
